// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ncsWfgDm{word-wrap:break-word;color:#000;font-size:.88rem;line-height:1.14;overflow:hidden}@media(hover:hover){.ncsWfgDm:hover{color:#000}}@media(hover:none){.ncsWfgDm:active{color:#000}}.rYboNXSr{--rabbet-color:#c5cde7}@media(hover:hover){.rYboNXSr:hover{--rabbet-color:#1a153f}}@media(hover:none){.rYboNXSr:active{--rabbet-color:#1a153f}}.U-YFbPd-{height:13.6em;margin-bottom:1.52em;padding:2.93em 3.12em 0}.Hgnzojty{height:100%;-o-object-fit:contain;object-fit:contain;width:100%}.qG37-6S5{padding:1.52em max(.88rem,min(1.67vw,2rem)) max(.88rem,min(1.67vw,2rem))}.h2-2L7YH{font-size:max(.88rem,min(.94vw,1.13rem));-webkit-hyphens:auto;hyphens:auto;line-height:1;margin-bottom:1.14em}.Jyyook\\+l{margin-bottom:3.29em}.zgSpav1g{gap:1em;line-height:1.36}.SEw7LZQE{background:none;color:inherit;cursor:pointer;font-weight:inherit;gap:.5em}.SEw7LZQE svg>*{fill:currentColor}@media(hover:hover){.SEw7LZQE:hover{opacity:.8}}@media(hover:none){.SEw7LZQE:active{opacity:.8}}.SEw7LZQE:active{opacity:.7}.oZ-\\+KpcH{color:#b1ec52}.YGD9zPZM{--pos:16px;pointer-events:none;right:16px;right:var(--pos);top:16px;top:var(--pos)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ncsWfgDm",
	"exhibitor": "rYboNXSr",
	"imgContainer": "U-YFbPd-",
	"img": "Hgnzojty",
	"meta": "qG37-6S5",
	"name": "h2-2L7YH",
	"description": "Jyyook+l",
	"bottom": "zgSpav1g",
	"like": "SEw7LZQE",
	"likeActive": "oZ-+KpcH",
	"label": "YGD9zPZM"
};
module.exports = ___CSS_LOADER_EXPORT___;
